// Core
import { Box, Image, Button, Grid, Flex, Text } from '@chakra-ui/react';
import { IoLocationSharp, IoPeople } from 'react-icons/io5';
import { TbRainbow } from 'react-icons/tb';
import { MdWork } from 'react-icons/md';
import { FaGenderless, FaRuler, FaReact } from 'react-icons/fa';
import { MdOutlineInterests } from 'react-icons/md';
import { FaTelegramPlane } from 'react-icons/fa';
import { SiGotomeeting } from 'react-icons/si';

// Assets
import { textLang } from 'services/Lang';

const MatchInfo = ({ item, type }) => {
  const textColor = '#2b2b2b';

  return (
    <Box p="30px 20px 30px 20px">

      <Box>
        <Flex justifyContent='space-between' alignItems='center' w="80%">
          <Text variant='title-xl' w='100%' textShadow="1px 1px black">{item?.name}</Text>
        </Flex>

        <Text 
          variant="text-md" 
          mt="16px"
        >
          {item?.description}
        </Text>

        <Flex mt="24px" justifyContent="space-between" py="12px" alignItems="center" borderBottom="1px solid #cccccc4a">
          <Flex alignItems="center" gap="8px">
            <IoPeople color={textColor} fontSize="21px" /> 
            <Text>{ item?.gender ? textLang(item?.gender) : '-'}</Text>
          </Flex>
        </Flex>

        <Flex justifyContent="space-between" py="12px" alignItems="center" borderBottom="1px solid #cccccc4a">
          <Flex alignItems="center" gap="8px">
            <SiGotomeeting color={textColor} fontSize="21px" /> 
            <Text>{ item?.for ? textLang(item?.for) : '-'}</Text>
          </Flex>
        </Flex>

        <Flex justifyContent="space-between" py="12px" alignItems="center" borderBottom="1px solid #cccccc4a">
          <Flex alignItems="center" gap="8px">
            <FaReact color={textColor} fontSize="21px" /> 
            <Text>{ item?.religion ? textLang(item?.religion) : '-'}</Text>
          </Flex>
        </Flex>
        
        <Flex gap='8px' mt='24px' flexWrap='wrap'>
          {item?.interests?.map((itm, index) => (
            <Box className='tag-interests' key={index}>{textLang(itm)}</Box>
          ))}
        </Flex>

        { type !== 'match' && (
          <Button as="a" href={item?.link} variant="button-md" px="16px !important" mt="24px">
            <FaTelegramPlane fontSize="24px" />
            <Text as="span" pl="12px" color="white">{textLang('open')}</Text>
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default MatchInfo;
